import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  padding: 30px 0px 30px 0px;

  background-color: ${colors.white};
  overflow: scroll;
`
export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.primary};
`
export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray7};
  margin-top: 10px;
`
export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.primary};
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Ul = styled.ul`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray7};
  margin-top: 10px;
`
export const Li = styled.li`
  margin-left: 32px;
  margin-bottom: 5px;
`
